import { ApiHelper } from './apiHelper';

export class DocumentApi {
    getDocumentDetails(
        policyReference,
        token,
        successCallback = null,
        failureCallback = null
    ) {
        var query = encodeURI(`?policyReference=${policyReference}`);
        var dataUrl = '/api/document/getdocumentdetails' + query;
        new ApiHelper().getDataSecure(
            dataUrl,
            token,
            successCallback,
            failureCallback
        );
    }
    getDownloadDocument(
        id,
        token,
        successCallback = null,
        failureCallback = null
    ) {
        var query = encodeURI(`?Id=${id}`);
        var dataUrl = '/api/document/getdownloaddocument' + query;
        new ApiHelper().getDataSecure(
            dataUrl,
            token,
            successCallback,
            failureCallback
        );
    }
}
